/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timer_PauseInputs */

const en_timer_pause = /** @type {(inputs: Timer_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause timer`)
};

const de_timer_pause = /** @type {(inputs: Timer_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer pausieren`)
};

/**
* | output |
* | --- |
* | "Pause timer" |
*
* @param {Timer_PauseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const timer_pause = /** @type {((inputs?: Timer_PauseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_PauseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_timer_pause(inputs)
	return en_timer_pause(inputs)
});